<h1 mat-dialog-title class="mat-dialog-title">{{ data.title }}</h1>
<div mat-dialog-content class="mat-dialog-content">
  <ng-template #target></ng-template>
</div>
<div mat-dialog-actions style="float: right" class="mat-dialog-actions">
  <!-- <button mat-button mat-dialog-close>Close</button> -->
  <!-- <button mat-button [mat-dialog-close]="true">Close</button> -->
</div>
